/**
 * Rotas contempladas pelo chat comercial de pós-graduação (HN-3170).
 *
 * O fluxo só existe nestas páginas — em qualquer outra, o site continua
 * usando o chat padrão (Chatwoot/Atalia no desktop, botão de WhatsApp
 * no mobile).
 */
export function isPostgraduateChatRoute(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false
  }

  if (pathname === '/cursos/pos-graduacoes') {
    return true
  }

  return pathname.startsWith('/pos-graduacoes/info/')
}
